import { useQuery } from "@tanstack/react-query";
import { useTenantInstance } from "@/contexts/TenantInstanceContext";
import { instanceHeaders } from "@/hooks/use-access";
import { apiRequest } from "@/lib/api";
import type { InstancePlatformResources } from "@shared/types/instances";

/** `platform.instances.manage` (PlatformAdmin only); identifiers, never a value (SEC-17). */
export const PLATFORM_RESOURCES_PATH = "/api/v2/instances/current/platform-resources";

/**
 * What the platform provisioned for the selected instance, for the destination page's
 * "Platform resources". `enabled` is the caller's permission check: a user without the
 * permission never sends the request, so there is no 403 to handle and nothing to hide.
 */
export function usePlatformResources(enabled: boolean) {
  const { selectedInstance } = useTenantInstance();
  return useQuery<InstancePlatformResources>({
    queryKey: [PLATFORM_RESOURCES_PATH, selectedInstance?.id],
    enabled: enabled && Boolean(selectedInstance),
    // See `instanceHeaders` in `use-access.ts` for why the header is explicit.
    queryFn: async ({ signal }) =>
      apiRequest<InstancePlatformResources>(PLATFORM_RESOURCES_PATH, {
        signal,
        headers: instanceHeaders(selectedInstance?.id),
      }),
  });
}
